var Affiliation;
(function (Affiliation) {
    Affiliation[Affiliation["HAGERTY"] = 0] = "HAGERTY";
    Affiliation[Affiliation["STFRM"] = 1] = "STFRM";
})(Affiliation || (Affiliation = {}));
var AssetStatus;
(function (AssetStatus) {
    AssetStatus[AssetStatus["ACTIVE"] = 0] = "ACTIVE";
    AssetStatus[AssetStatus["EXPIRED"] = 1] = "EXPIRED";
    AssetStatus[AssetStatus["CANCELED"] = 2] = "CANCELED";
    AssetStatus[AssetStatus["INACTIVE"] = 3] = "INACTIVE";
})(AssetStatus || (AssetStatus = {}));
var ProductType;
(function (ProductType) {
    ProductType[ProductType["MEMBERSHIP"] = 0] = "MEMBERSHIP";
    ProductType[ProductType["RADIUS"] = 1] = "RADIUS";
})(ProductType || (ProductType = {}));
var VehicleType;
(function (VehicleType) {
    VehicleType[VehicleType["CLASSIC"] = 0] = "CLASSIC";
    VehicleType[VehicleType["HOUSEHOLD"] = 1] = "HOUSEHOLD";
    VehicleType[VehicleType["COLLECTOR"] = 2] = "COLLECTOR";
    VehicleType[VehicleType["ALLVEHICLES"] = 3] = "ALLVEHICLES";
})(VehicleType || (VehicleType = {}));

export { Affiliation, AssetStatus, ProductType, VehicleType };
